<template>
  <WrapperFormControl
    v-bind="{
      label,
      tooltip,
      error,
      required: $attrs.required,
    }"
    class="carousel-selector"
    :class="{
      'd-flex flex-column': !items.length,
    }"
  >
    <Carousel
      slot="control"
      :items="items"
      :item-size="itemSize + 16"
      :arrow-width="isLargeGame ? 32 : 24"
      :empty-text="emptyText"
      :class="{ 'flex-grow-1': !items.length }"
    >
      <div
        slot="carouselItem"
        slot-scope="{ item }"
        class="w-100 px-3 text-center carousel-selector__item"
        :class="{
          'carousel-selector__item--active': isActive(item),
        }"
        :title="item.name || item.title"
        @click="setActive(item)"
      >
        <component
          :is="component"
          v-bind="componentProps(item)"
          :class="{
            'adjust-btn-height': adjustButton,
            'cursor-default': readOnly,
            'cursor-pointer': !readOnly,
          }"
        />
        <TextBlock
          v-if="!hideItemTitle"
          class="mt-3 mb-0 text-truncate"
          :class="{ 'mx-n1': !isLargeGame }"
          tag="p"
          :size="isLargeGame ? 1 : 0.625"
          :variant="isActive(item) ? 'primary' : 'secondary'"
          :text="item.name || item.title"
        />
      </div>
    </Carousel>
  </WrapperFormControl>
</template>

<script>
import { prop, propRequired } from '@/utils/factories';
import Avatar from '@/components/images/Avatar';
import GameCard from '@/components/common/GameCard';
import TextBlock from '@/components/atoms/TextBlock';
import Carousel from '@/views/account/content/teams/clanTeams/carousel';
import WrapperFormControl from '@/components/atoms/form/WrapperFormControl';

export default {
  name: 'CarouselSelector',
  components: {
    Avatar,
    GameCard,
    TextBlock,
    Carousel,
    WrapperFormControl,
  },
  props: {
    value: prop([Object, Array]),
    label: prop(String),
    variant: prop(String, 'small'), // 'large', 'medium', 'small'
    type: prop(String, 'platform'), // 'game', 'platform'
    propName: prop(String, 'id'),
    adjustButton: prop(Boolean, true),
    multiSelect: prop(Boolean),
    tooltip: prop(String),
    readOnly: prop(Boolean),
    items: propRequired(Array),
    error: prop(String),
    emptyText: prop(String),
    hideItemTitle: prop(Boolean),
  },
  computed: {
    isLargeGame() {
      return this.type === 'game' && this.variant === 'large';
    },
    isSmallGame() {
      return this.type === 'game' && !this.isLargeGame;
    },
    isMediumGame() {
      return this.type === 'game' && this.variant === 'medium';
    },
    component() {
      return this.isLargeGame || this.isSmallGame ? GameCard : Avatar;
    },
    itemSize() {
      return this.isLargeGame
        ? this.$options.cardSizes.largeCardSize
        : this.isMediumGame || this.variant === 'medium'
        ? this.$options.cardSizes.largeCardHeight
        : this.$options.cardSizes.smallCardSize;
    },
  },
  created() {
    this.$options.cardSizes = {
      smallImage: 36,
      smallCardSize: 56,
      largeCardSize: 140,
      largeCardHeight: 85,
    };
  },
  methods: {
    isActive(item) {
      return (
        (Array.isArray(this.value) && this.value.includes(item.value)) ||
        (this.value &&
          this.value[this.propName] &&
          this.value[this.propName] === item[this.propName])
      );
    },
    componentProps(item) {
      return this.isLargeGame
        ? {
            height: this.$options.cardSizes.largeCardHeight,
            width: this.itemSize,
            game: item,
            isActive: this.isActive(item),
            class: 'd-flex flex-grow-1',
          }
        : this.isSmallGame
        ? {
            height: 56,
            width: 56,
            game: item,
            isActive: this.isActive(item),
            class: 'd-flex flex-grow-1',
          }
        : this.variant === 'medium'
        ? {
            'img-url': item.img || item.logo,
            size: this.$options.cardSizes.smallCardSize,
          }
        : {
            'img-url': item.img || item.logo,
            size: this.$options.cardSizes.smallImage,
          };
    },
    setActive(item) {
      if (this.readOnly) {
        return;
      }
      if (!this.multiSelect) {
        return this.$emit('input', item);
      }
      let newVal;
      const id = item[this.propName];
      if (this.value.find(val => val === id || val[this.propName] === id)) {
        newVal = this.value.filter(p => p !== item[this.propName]);
      } else {
        newVal = [...this.value, item.value];
      }
      this.$emit('input', newVal);
    },
  },
};
</script>

<style lang="scss">
.carousel-selector {
  .carousel-selector__item {
    opacity: 0.75;
    * {
      // &:not(p) {
      //   filter: grayscale(100%);
      // }
      opacity: 1;
    }
    &--active {
      // > :not(p) {
      //   border: 1px solid $ph-accent;
      //   background-color: $ph-accent;
      // }
      opacity: 1;
      // * {
      //   filter: unset !important;
      // }
    }
  }
  .carousel-control-wrapper {
    &:first-of-type {
      @include auto-rtl(margin-right, 0.25rem !important);
    }
    &:last-of-type {
      @include auto-rtl(margin-left, 0.25rem !important);
    }
  }
}
</style>
